const productList = function productList(data) {
  let ret = '';

  $.each(data.products, function(index, row) {
    ret += htmlProductList(row);
  });

  let productCount = (data.page.count === undefined) ? 0 : data.page.count;
  $('#ProductCountDesktop').html(productCount+'個の商品');
  $('#ProductCount').html(productCount+'個の商品');
  $('.sync_product_list').html(ret);
  $('.sync_pagination-wrapper').html(htmlProudctPagination(data.page));
}

function getPaginateUrl(num) {
  const url = new URL(location.href);
  url.searchParams.set('page',num);
  url.searchParams.set('sort_by',$('#SortBy').val());
  return 'https://' + location.host + location.pathname + url.search;
}

function htmlProudctPagination(data) {
  let ret = '';

  if (data.min === undefined || data.max === undefined || data.max === 0) {
    return ret;
  }
  ret += '<nav class="pagination" role="navigation" aria-label="ページネーション">';
  ret += '<ul class="pagination__list list-unstyled" role="list">';

  if (currentPage != "1" && data.max != "1") {
    ret += '<li>';
    ret += '<a href="'+getPaginateUrl(parseInt(currentPage) - 1)+ '" class="pagination__item pagination__item--next pagination__item-arrow link motion-reduce">';
    ret += '<span class="svg-wrapper"><img src="'+prevImg+'"></span>';
    ret += '</a>';
    ret += '</li>';
  }

  for (let i=data.min; i<=data.max; i++) {
    ret += '<li>';
    if (i == currentPage) {
      ret += '<a role="link" aria-disabled="true" class="pagination__item pagination__item--current light" aria-current="page" aria-label="'+i+'ページ">';
    } else {
      ret += '<a href="'+getPaginateUrl(i)+'" class="pagination__item link" aria-label="'+i+'ページ">';
    }
    ret += i;
    ret += '</a>';
    ret += '</li>';
  }

  if (currentPage != data.max && data.max != "1") {
    ret += '<li>';
    ret += '<a href="'+getPaginateUrl(parseInt(currentPage) + 1)+ '" class="pagination__item pagination__item--prev pagination__item-arrow link motion-reduce">';
    ret += '<span class="svg-wrapper"><img src="'+prevImg+'"></span>';
    ret += '</a>';
    ret += '</li>';
  }

  ret += '</ul>';
  ret += '</nav>';

  return ret;
}

function htmlProductList(data) {
  let ret = '';
  const link = '/products/'+data.handle+'?variant='+data.variant_id;
  ret += '<li class="grid__item scroll-trigger animate--slide-in" data-cascade="" style="--animation-order: 3;">';
  ret += '<div class="card-wrapper product-card-wrapper underline-links-hover">';
  ret += '<div class="card card--standard card--media" style="--ratio-percent: 100%;">';
  ret += '<div class="card__inner color-scheme-2 gradient ratio" style="--ratio-percent: 100%;">';
  ret += '<div class="card__media">';
  ret += '<div class="media media--transparent media--hover-effect">';
  ret += '<img src="'+data.image+'" alt="'+data.title+'" class="motion-reduce" width="720" height="960">';
  ret += '</div>';
  ret += '<div class="card__content">';
  ret += '<div class="card__information">';
  ret += '<h3 class="card__heading">';
  ret += '<a href="'+link+'" class="full-unstyled-link" >';
  ret += data.title;
  ret += '</a>';
  ret += '</h3>';
  ret += '</div>';
  ret += '</div>';
  ret += '<div class="card__badge bottom left"></div>';
  ret += '</div>';
  ret += '</div>';
  ret += '<div class="card__content">';
  ret += '<div class="card__information">';
  if (data.is_new) {
    ret += '<div class="product__tag_new">新商品</div>';
  }
  if (data.product_number === null || data.product_number === undefined) {
    ret += '<p class="product__pnumber">商品番号：</p>';    
  } else {
    ret += '<p class="product__pnumber">商品番号：'+data.product_number+'</p>';    
  }
  ret += '<h3 class="card__heading h5">';
  ret += '<a href="'+link+'" class="full-unstyled-link">';
  ret += data.title;
  ret += '</a>';
  ret += '</h3>';
  ret += '<div class="card-information"><span class="caption-large light"></span>';
  if (data.compare_at_price != 0) {
    ret += '<div class="price  price--on-sale">';
    ret += '<div class="price__container">';
    ret += '<div class="price__sale">';
    ret += '<span class="visually-hidden visually-hidden--inline">通常価格</span>';
    ret += '<span>';
    ret += '<s class="price-item price-item--regular variant-item__old-price">';
    ret += '¥'+data.compare_at_price;
    ret += '</s>';
    ret += '</span>';
    ret += '</div>';
    ret += '<span class="price-item price-item--sale price-item--last">';
    ret += '¥'+data.price+'<span class="price-item__tax">(税込)</span>';
    ret += '</span>';
    ret += '</div>';
    ret += '</div>';
  } else {
    ret += '<div class="price">';
    ret += '<div class="price__container">';
    ret += '<div class="price__sale">';
    ret += '<span class="visually-hidden visually-hidden--inline">通常価格</span>';
    ret += '<span>';
    ret += '<s class="price-item price-item--regular variant-item__old-price">';
    ret += '</s>';
    ret += '</span>';
    ret += '</div>';
    ret += '<span class="price-item price-item--sale price-item--last">';
    ret += '¥'+data.price+'<span class="price-item__tax">(税込)</span>';
    ret += '</span>';    
    ret += '</div>';
    ret += '</div>';
  }

  ret += '</div>';
  ret += '</div>';
  ret += '<div class="card__badge bottom left"></div>';
  ret += '</div>';
  ret += '</div>';
  ret += '</div>';
  ret += '</li>';

  return ret;
}

// 商品一覧のパラメータ
function getProductListParam() {
  let param;
  let sort = $('#SortBy').val();
  param = '?user_key='+userKey+'&yen_more='+yenMore+'&less_than_yen='+lessThanYen+'&per_page='+productsPerPage+'&page='+currentPage+'&sort='+sort+'&collection='+collectionJson;
  return param;
}

const doProductList = function(){
  let param = getProductListParam();
  fetchBase(mallDomain + "/admin/product-list/"+param, productList);
}

doProductList();

$(document).on('change', '#SortBy', function(){
  currentPage = 1;
  doProductList();
});
